import gql from 'graphql-tag';

export const CREATE_SURVEY_ANSWERS = gql`
  mutation createSurveyAnswers(
    $surveyAnswers: [SurveyAnswerInput!]
  ) {
    createSurveyAnswers(
      surveyAnswers: $surveyAnswers
    ) {
      success
    }
  }
`;
